import * as THREE from "three";
import type { EnvironmentPreset } from "./environmentPresets";
import { DEFAULT_ENVIRONMENT } from "./environmentPresets";
import type { ObservationEnvironment } from "./observationEnvironment";
import type { ObservationLighting } from "./observationLighting";

export interface EnvironmentController {
  setPreset: (preset: EnvironmentPreset) => void;
  update: (deltaSeconds: number) => void;
}

export function createEnvironmentController(
  scene: THREE.Scene,
  lighting: ObservationLighting,
  environment: ObservationEnvironment,
): EnvironmentController {
  if (!(scene.background instanceof THREE.Color) || !(scene.fog instanceof THREE.FogExp2)) {
    throw new Error("Observation environments require a color background and exponential fog.");
  }

  const background = scene.background;
  const fog = scene.fog;
  const targetBackground = new THREE.Color(DEFAULT_ENVIRONMENT.scene.background);
  const targetFog = new THREE.Color(DEFAULT_ENVIRONMENT.scene.fog);
  let targetFogDensity = DEFAULT_ENVIRONMENT.scene.fogDensity;

  return {
    setPreset(preset): void {
      targetBackground.setHex(preset.scene.background);
      targetFog.setHex(preset.scene.fog);
      targetFogDensity = preset.scene.fogDensity;
      lighting.setPreset(preset);
      environment.setPreset(preset);
    },
    update(deltaSeconds): void {
      const easing = 1 - Math.exp(-deltaSeconds * 1.8);
      background.lerp(targetBackground, easing);
      fog.color.lerp(targetFog, easing);
      fog.density = THREE.MathUtils.lerp(fog.density, targetFogDensity, easing);
      lighting.update(deltaSeconds);
    },
  };
}

